import { render } from "./TacheItem.ts.vue?vue&type=template&id=6b1ae0ae&ts=true"
import script from "./TacheItem.ts.vue?vue&type=script&lang=ts"
export * from "./TacheItem.ts.vue?vue&type=script&lang=ts"

import "./TacheItem.ts.vue?vue&type=style&index=0&id=6b1ae0ae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__